import React, { useState } from 'react'
import { countries } from 'helper/states'
import { Button, Checkbox, PhoneInput, Select, TextInput, useView } from 'components/lib'
import { useParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

export default function ForwardingNumber(props) {
    const { id } = useParams()
    const view = useView()
    const [data, setData] = useState(props.data)

    const handleChange = (name, value) => {
        setData({ ...data, [name]: value })
    }

    const mutation = useMutation({
        mutationFn: () => axios.put(`/api/campaign/${id}/forwarding_number`, data),
        onSuccess: () => {
            view.notification.show(`Forwarding Number was saved`, 'success', true);
        },
        onError: (error) => {
            view.handleError(error)
        }
    })

    return (
        <div>
            <div className='grid gap-4'>
                <div className="grid grid-cols-2 gap-2">
                    <Select
                        name={"country"}
                        label={'Country'}
                        default={data.country}
                        options={countries}
                        onChange={handleChange}
                    />
                    <PhoneInput
                        name={"callforwarding_number"}
                        label={"FWD Number"}
                        value={data.callforwarding_number}
                        onChange={handleChange}
                    />
                </div>

                <div className='grid gap-4'>
                    <Checkbox
                        name={"two_way_sms_number_enabled"}
                        option={"Two Way SMS Number Enabled"}
                        checked={data.two_way_sms_number_enabled}
                        onChange={handleChange}
                    />
                    {
                        data.two_way_sms_number_enabled ? (
                            <div className="grid grid-cols-2 gap-2">
                                <Select
                                    name={"two_way_sms_number_country"}
                                    label={'Country'}
                                    default={data.two_way_sms_number_country}
                                    options={countries}
                                    onChange={handleChange}
                                />
                                <PhoneInput
                                    name={"two_way_sms_number"}
                                    label={"2-WAY SMS Number"}
                                    value={data.two_way_sms_number}
                                    onChange={handleChange}
                                />
                                <div className='col-span-2'>
                                    <TextInput
                                        name={"two_way_sms_number_app_id"}
                                        label={"App ID"}
                                        value={data.two_way_sms_number_app_id}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        ) : undefined
                    }
                </div>
                <Button
                    text='Save'
                    action={mutation.mutate}
                    loading={mutation.isPending}
                />
            </div>
        </div>
    )
}
